/*
 * @Author: your name
 * @Date: 2021-12-02 16:55:43
 * @LastEditTime: 2021-12-02 16:55:45
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \vue3-element-admin\src\store\modules\app\type.js
 */
export const TOGGLE_SLIDER = "TOGGLE_SLIDER";
export const SET_TOKEN = "SET_TOKEN";
export const SET_UNAME = "SET_UNAME";
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_MENU_LIST = "SET_MENU_LIST";
export const SET_PERMISSION_LIST = "SET_PERMISSION_LIST";
export const SET_PRODUCT = "SET_PRODUCT";
export const ASYNC_SET_PRODUCT = "ASYNC_SET_PRODUCT";
export const SET_BREADCRUMB_LIST = "SET_BREADCRUMB_LIST";
export const CLEAR_BREADCRUMB_LIST = "CLEAR_BREADCRUMB_LIST";

